import { z } from 'zod';
import { UserRole } from '~/app-modules/user-access-right/clients/enums/user-role';

export const UserAccessRightResponse = z.object({
  id: z.string(),
  userId: z.string(),
  userRole: z.nativeEnum(UserRole),
  resourceId: z.nullable(z.string()),
  createdAt: z.coerce.date(),
});

export type TUserAccessRightResponse = z.infer<typeof UserAccessRightResponse>;
